document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('nav');
  if (menu && nav) menu.addEventListener('click', () => { const open = nav.classList.toggle('open'); menu.setAttribute('aria-expanded', String(open)); });

  const date = document.getElementById('preferred-date');
  if (date) {
    const today = new Date();
    const iso = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    date.min = iso(today);
    const checkWeekend = () => {
      if (!date.value) { date.setCustomValidity(''); return; }
      const chosen = new Date(`${date.value}T12:00:00`);
      date.setCustomValidity((chosen.getDay() === 0 || chosen.getDay() === 6) ? '' : 'Please select a Saturday or Sunday.');
    };
    date.addEventListener('input', checkWeekend);
    date.addEventListener('change', () => { checkWeekend(); if (!date.checkValidity()) date.reportValidity(); });
    date.closest('form')?.addEventListener('submit', e => { checkWeekend(); if (!date.checkValidity()) { e.preventDefault(); date.reportValidity(); } });
  }

  const prices = {
    'One-time wash': {base:80, additional:60, intro:60},
    'Every 2 weeks': {base:55, additional:35, intro:35},
    'Every 4 weeks': {base:60, additional:39, intro:40}
  };
  const whole = (value,min=1,max=50) => {
    const n = Number(value);
    return Number.isSafeInteger(n) && n >= min && n <= max ? n : null;
  };
  const frequency = document.getElementById('booking-frequency');
  const vehicles = document.getElementById('booking-vehicles');
  const estimate = document.getElementById('booking-price');
  const estimateNote = document.getElementById('booking-price-note');
  const calcPrice = document.getElementById('calc-price');
  const calcAverage = document.getElementById('calc-average');
  const choices = [...document.querySelectorAll('.vehicle-choice')];
  const otherWrap = document.getElementById('other-cars-wrap');
  const otherInput = document.getElementById('other-cars');
  const money = n => '$' + n.toLocaleString('en-US');

  function updateBooking() {
    const n = whole(vehicles?.value);
    const plan = prices[frequency?.value];
    if (!estimate) return;
    if (!plan || n === null) {
      estimate.textContent = 'Select frequency and vehicle count';
      if (estimateNote) estimateNote.textContent = 'Your price will appear after both selections are made.';
      return;
    }
    const first = plan.intro + (n-1)*plan.additional;
    const standard = plan.base + (n-1)*plan.additional;
    estimate.textContent = money(first);
    if (estimateNote) estimateNote.textContent = `New-customer first wash · Regular ${frequency.value.toLowerCase()} total: ${money(standard)} per appointment. Final quote confirmed by text.`;
  }
  function updateCalculator(n) {
    if (n === null) {
      if (calcPrice) calcPrice.textContent = '—';
      if (calcAverage) calcAverage.textContent = 'Enter a whole number from 5 to 50';
      return;
    }
    const total = 60 + (n-1)*39;
    if (calcPrice) calcPrice.textContent = money(total);
    if (calcAverage) calcAverage.textContent = `${money(Math.round(total/n*100)/100)} per vehicle`;
  }
  choices.forEach(button => button.addEventListener('click', () => {
    const other = button.dataset.cars === 'other';
    choices.forEach(b => { const active = b === button; b.classList.toggle('selected',active); b.setAttribute('aria-pressed',String(active)); });
    if (otherWrap) otherWrap.hidden = !other;
    if (other) { otherInput?.focus(); updateCalculator(whole(otherInput?.value,5)); }
    else { const n = whole(button.dataset.cars); updateCalculator(n); if (vehicles) { vehicles.value = n; updateBooking(); } }
  }));
  otherInput?.addEventListener('input', () => {
    const n = whole(otherInput.value,5);
    updateCalculator(n);
    if (vehicles) { vehicles.value = n ?? ''; updateBooking(); }
  });
  frequency?.addEventListener('change', updateBooking);
  vehicles?.addEventListener('input', updateBooking);
  document.querySelectorAll('.plan-book').forEach(link => link.addEventListener('click', () => { if (frequency) { frequency.value = link.dataset.plan; updateBooking(); } }));
  updateBooking();

  // Curated common makes and models; customers can choose Other and specify a model in notes.
  const catalog = {
    Acura:['Integra','MDX','RDX','TLX','Other'], Alfa_Romeo:['Giulia','Stelvio','Tonale','Other'], Audi:['A3','A4','A5','A6','Q3','Q5','Q7','Q8','e-tron','Other'], BMW:['2 Series','3 Series','4 Series','5 Series','7 Series','X1','X3','X5','X7','i4','iX','Other'], Buick:['Encore','Encore GX','Enclave','Envista','Other'], Cadillac:['CT4','CT5','Escalade','XT4','XT5','XT6','Lyriq','Other'], Chevrolet:['Blazer','Camaro','Colorado','Corvette','Equinox','Malibu','Silverado','Suburban','Tahoe','Traverse','Trax','Other'], Chrysler:['300','Pacifica','Voyager','Other'], Dodge:['Challenger','Charger','Durango','Hornet','Other'], Fiat:['500','500X','Other'], Ford:['Bronco','Bronco Sport','Edge','Escape','Expedition','Explorer','F-150','F-250','F-350','Maverick','Mustang','Ranger','Transit','Other'], Genesis:['G70','G80','G90','GV60','GV70','GV80','Other'], GMC:['Acadia','Canyon','Sierra','Terrain','Yukon','Other'], Honda:['Accord','Civic','CR-V','HR-V','Odyssey','Passport','Pilot','Ridgeline','Other'], Hyundai:['Elantra','Ioniq 5','Ioniq 6','Kona','Palisade','Santa Cruz','Santa Fe','Sonata','Tucson','Venue','Other'], Infiniti:['Q50','QX50','QX55','QX60','QX80','Other'], Jaguar:['E-Pace','F-Pace','F-Type','I-Pace','Other'], Jeep:['Cherokee','Compass','Gladiator','Grand Cherokee','Renegade','Wagoneer','Wrangler','Other'], Kia:['Carnival','EV6','EV9','Forte','K5','Niro','Seltos','Sorento','Soul','Sportage','Telluride','Other'], Land_Rover:['Defender','Discovery','Discovery Sport','Range Rover','Range Rover Evoque','Range Rover Sport','Velar','Other'], Lexus:['ES','GX','IS','LS','LX','NX','RX','TX','UX','Other'], Lincoln:['Aviator','Corsair','Nautilus','Navigator','Other'], Lucid:['Air','Gravity','Other'], Mazda:['CX-30','CX-5','CX-50','CX-70','CX-90','Mazda3','MX-5 Miata','Other'], Mercedes_Benz:['A-Class','C-Class','CLA','E-Class','G-Class','GLA','GLB','GLC','GLE','GLS','S-Class','Other'], Mini:['Cooper','Countryman','Other'], Mitsubishi:['Eclipse Cross','Mirage','Outlander','Outlander Sport','Other'], Nissan:['Altima','Armada','Frontier','Kicks','Leaf','Maxima','Murano','Pathfinder','Rogue','Sentra','Titan','Versa','Z','Other'], Polestar:['Polestar 2','Polestar 3','Polestar 4','Other'], Porsche:['911','Cayenne','Macan','Panamera','Taycan','Other'], Ram:['1500','2500','3500','ProMaster','Other'], Rivian:['R1S','R1T','Other'], Subaru:['Ascent','BRZ','Crosstrek','Forester','Impreza','Legacy','Outback','Solterra','WRX','Other'], Tesla:['Model 3','Model S','Model X','Model Y','Cybertruck','Other'], Toyota:['4Runner','Camry','Corolla','Crown','Grand Highlander','Highlander','Land Cruiser','Prius','RAV4','Sequoia','Sienna','Tacoma','Tundra','Other'], Volkswagen:['Atlas','Golf GTI','ID.4','Jetta','Taos','Tiguan','Other'], Volvo:['EX30','EX90','S60','S90','V60','XC40','XC60','XC90','Other'], Other:['Other / not listed']
  };
  const vehicleDetails = document.getElementById('vehicle-details');
  const colors = ['Black','White','Silver','Gray','Blue','Red','Green','Brown','Beige / Tan','Gold','Orange','Yellow','Purple','Other / Custom'];
  const makeKeys = Object.keys(catalog).sort();
  const makeLabel = key => key.replaceAll('_',' ');
  const option = (value, label=value) => new Option(label,value);
  function buildVehicleFields() {
    if (!vehicleDetails) return;
    const count = whole(vehicles?.value);
    vehicleDetails.replaceChildren();
    if (count === null) {
      const tip = document.createElement('p');
      tip.className = 'vehicle-help';
      tip.textContent = 'Select a whole number of vehicles (1–50) to add their details.';
      vehicleDetails.appendChild(tip);
      return;
    }
    const fragment = document.createDocumentFragment();
    for (let i=1; i<=count; i++) {
      const group = document.createElement('fieldset');
      group.className = 'vehicle-detail-group';
      const legend = document.createElement('legend');
      legend.textContent = `Vehicle ${i}`;
      group.appendChild(legend);
      const row = document.createElement('div');
      row.className = 'vehicle-detail-row';
      const createSelect = (labelText, key, placeholder) => {
        const label = document.createElement('label');
        label.textContent = labelText;
        const select = document.createElement('select');
        select.required = true;
        select.name = `contact[Vehicle ${i} ${key}]`;
        select.setAttribute('aria-label',`Vehicle ${i} ${labelText}`);
        select.add(option('',placeholder));
        label.appendChild(select);
        row.appendChild(label);
        return select;
      };
      const make = createSelect('Make','make','Select make');
      const model = createSelect('Model','model','Select make first');
      const color = createSelect('Color','color','Select color');
      model.disabled = true;
      makeKeys.forEach(key => make.add(option(makeLabel(key))));
      colors.forEach(c => color.add(option(c)));
      make.addEventListener('change', () => {
        model.replaceChildren(option('','Select model'));
        const key = make.value.replaceAll(' ','_');
        (catalog[key] || ['Other']).forEach(m => model.add(option(m)));
        model.disabled = !make.value;
      });
      group.appendChild(row);
      fragment.appendChild(group);
    }
    vehicleDetails.appendChild(fragment);
  }
  vehicles?.addEventListener('input',buildVehicleFields);
  vehicles?.addEventListener('change',buildVehicleFields);
  buildVehicleFields();
  const sticky = document.createElement('div');
  sticky.className = 'sticky-mobile-book';
  sticky.innerHTML = '<a href="#book">REQUEST YOUR WEEKEND WASH ↗</a>';
  document.body.appendChild(sticky);
});
